import { createContext } from '@rc-component/context';
export var StaticContext = createContext(null);
export var GridContext = createContext(null);